<template>
  <div>
    <el-card>
      <edit-form
        :disabled="isDisableEditForm"
        :billCartonTransferCode="this.params.code"
        ref="editForm"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  name: 'samplemanage-cartonTransfer-detail',
  components: {
    EditForm,
  },
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      formData: {},
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },

    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },

  methods: {
    ...mapActions('admin/page', ['close']),
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
